module.exports = __webpack_public_path__ + "img/little-asymmetry.d1a71827.svg";